module.exports = __webpack_public_path__ + "img/IT.f3ceb227.png";